import * as t from "./types";
import React, { useRef, useState } from "react";
import * as api from "./Api";

const leadingSpaces = /^\s+/g; //new RegExp("^\\s+", "g");
const multipleSpaces = /\s+/g; //new RegExp("\\s+", "g");
const trailingSpaces = /\s+$/g; //new RegExp("\\s+$", "g");

const strEq = (a: string, b: string) => {
  const aClean = a
    .replaceAll(leadingSpaces, "") //remove
    .replaceAll(trailingSpaces, "") //remove
    .replaceAll(multipleSpaces, " "); //collapse
  const bClean = b
    .replaceAll(leadingSpaces, "") //remove
    .replaceAll(trailingSpaces, "") //remove
    .replaceAll(multipleSpaces, " "); //collapse
  return aClean === bClean;
};

interface ICancelRegistrationProps {
  notifyUpdate: (data: t.IData) => void;
  registrations: t.ITrainingRegistration[];
  notifySuccess: () => void;
  cancel: () => void;
}

export const CancelRegistration = (props: ICancelRegistrationProps) => {
  const nameRef = useRef<HTMLInputElement>(null);
  const { notifyUpdate, registrations, cancel, notifySuccess } = props;
  const [isValid, setIsValid] = useState(false);

  const checkValid = () => {
    const testName = nameRef.current?.value || "";
    console.log("testing against", testName);
    const found = registrations.find((r) => strEq(r.name, testName));
    if (isValid && !found) {
      setIsValid(false);
    } else if (!isValid && found) {
      setIsValid(true);
    } else {
      //state remains same
    }
  };

  const submit = () => {
    const found = registrations.find((r) =>
      strEq(r.name, nameRef.current?.value || "")
    );
    if (found) {
      api.unregister(found).then((res: t.IScheduleResponse) => {
        if (res.status === "success") {
          notifyUpdate(res.data);
          notifySuccess();
        } else {
        }
      });
    } else {
      //error message
      console.error("could not find registration for", nameRef.current?.value);
      console.log(registrations);
    }
  };
  return (
    <div>
      <label htmlFor="unref">
        <b>Abmelden:</b>
      </label>
      <input
        ref={nameRef}
        type="text"
        placeholder="Name"
        name="unreg"
        onChange={() => checkValid()}
      />
      {isValid ? (
        <button onClick={() => submit()}>Abmeldung Bestätigen</button>
      ) : (
        <button onClick={() => submit()} disabled>
          Abmeldung Bestätigen
        </button>
      )}
      <button onClick={() => cancel()}>Abbrechen</button>
    </div>
  );
};
